import React, { useMemo } from 'react';
import { v4 } from 'uuid';

// @todo Remove this hook and replace its usages with useId once full react 18 support is available
export const useStableId = id => {
  const reactId = React.useId?.();
  const randomId = useMemo(() => {
    return v4();
  }, []);
  return id ?? reactId ?? randomId;
};